/* The store's own prices and variants, for whichever Mirror this is.
   Every Mirror has the same three options (Frame style, Color, Mat Color); their values are matched without
   regard to capitals, because the store writes "No mat" on some Mirrors and "No Mat" on others. */
(() => {
  const product=window.ViuletJourneyProduct,config=window.VIULET_GALLERY_CONFIG;
  if(!product||!config)return;
  // Where this Mirror was designed, kept on its order line (keys starting with _ never show to the customer).
  const designed=()=>({_design_source:'mirror_page',_design_page:window.location.pathname,_design_version:'1'});
  const currency=window.ViuletJourneyCurrency||'USD';
  const same=(a,b)=>String(a??'').trim().toLowerCase()===String(b??'').trim().toLowerCase();
  const names=product.options.map(o=>typeof o==='string'?o:o.name);
  const place=(name,fallback)=>{const i=names.findIndex(n=>same(n,name));return i<0?fallback:i;};
  const STYLE=place('Frame style',0),COLOR=place('Color',1),MAT=place('Mat Color',2);
  const FINISHES=['Seraph White','Nocturne Black','Atelier Wood','Midnight Silver','Midas Gold'],MATS=['White','Cream','Black'];
  const named=(value,list)=>list.find(name=>same(name,value));
  // An edition that is sold out can still be looked at in every presentation it was made in.
  const soldOut=!!config.soldOut;
  const offered=v=>soldOut||v.available;
  const matches=(v,s)=>same(v.options[STYLE],s.presentation)
    &&same(v.options[COLOR],s.presentation==='Untethered'?'No Frame':s.finish)
    &&same(v.options[MAT],['Haloed','Crowned'].includes(s.presentation)?s.mat:'No Mat');
  const find=s=>product.variants.find(v=>matches(v,s));
  const available=s=>{if(Number(s.printInches??s.size)!==20)return false;const v=find(s);return !!v&&offered(v);};
  config.previewPricing=false;
  // A Mirror is built to order. The designer says how long that takes, under its buttons.
  config.deliveryNote=soldOut?'':'Built to order in three to five weeks.';
  config.normalizeSelection=s=>{
    if(available(s))return s;
    const variant=product.variants.find(v=>offered(v)&&same(v.options[STYLE],s.presentation));
    if(!variant)return s;
    return {...s,finish:named(variant.options[COLOR],FINISHES)||s.finish,mat:named(variant.options[MAT],MATS)||s.mat};
  };
  // The presentation the page opens on must be one that can be chosen today: when the curator's own is not
  // offered, the nearest one that is takes its place, and the line under the artwork says which.
  const opening=config.artwork.defaultSelection;
  if(!available(opening)){
    let next=config.normalizeSelection(opening);
    if(!available(next)){
      const variant=product.variants.find(offered),style=variant&&['Untethered','Lined','Haloed','Crowned'].find(name=>same(name,variant.options[STYLE]));
      if(style)next={...opening,presentation:style,finish:named(variant.options[COLOR],FINISHES)||opening.finish,mat:named(variant.options[MAT],MATS)||opening.mat};
    }
    if(available(next)){
      config.artwork.defaultSelection=next;
      const root=document.getElementById('viulet-v36'),line=root?.querySelector('#hero-presentation'),poster=root?.querySelector('#hero-poster');
      const shown=[next.presentation,next.presentation!=='Untethered'?next.finish:null,['Crowned','Haloed'].includes(next.presentation)?next.mat:null].filter(Boolean);
      if(line)line.textContent=shown.join(' · ');
      if(poster)poster.alt=[config.artwork.title,'presented '+shown.join(', ')].filter(Boolean).join(', ');
    }
  }
  config.isChoiceAvailable=(s,field,value)=>{
    if(field==='presentation')return product.variants.some(v=>offered(v)&&same(v.options[STYLE],value));
    return available({...s,[field]:value});
  };
  config.optionPriceDifference=(s,field,value)=>{
    let rows=product.variants.filter(offered),chosen;
    if(field==='presentation')chosen=rows.filter(v=>same(v.options[STYLE],value));
    else{
      rows=rows.filter(v=>same(v.options[STYLE],s.presentation));
      if(field==='finish'){
        if(['Haloed','Crowned'].includes(s.presentation))rows=rows.filter(v=>same(v.options[MAT],s.mat));
        chosen=rows.filter(v=>same(v.options[COLOR],value));
      }else if(field==='mat'){
        rows=rows.filter(v=>same(v.options[COLOR],s.finish));chosen=rows.filter(v=>same(v.options[MAT],value));
      }
    }
    if(!chosen?.length||!rows.length)return null;
    return {amount:(Math.min(...chosen.map(v=>v.price))-Math.min(...rows.map(v=>v.price)))/100,currency};
  };
  config.resolvePrice=async s=>{
    if(Number(s.printInches??s.size)!==20)throw new Error('This edition is available in its original size only.');
    const v=find(s);
    if(!v||!offered(v))throw new Error('This presentation is currently unavailable.');
    return {amount:v.price/100,currency,variantId:v.id,test:false};
  };
  let request;
  config.onClaim=s=>{
    if(soldOut)return Promise.reject(new Error('This edition is sold out.'));
    if(request)return request;
    request=(async()=>{
      const quote=await config.resolvePrice(s),root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:quote.variantId,quantity:1,properties:{...designed(),...(window.ViuletUpsell?.mirrorProperties() || {})}}]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||'Your Mirror could not be added. Please try again.');
      window.ViuletUpsell?.completeMirror();
      window.location.assign(root+'cart');
    })().catch(e=>{request=null;throw e;});
    return request;
  };
})();
